var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 7H41.6838",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 52H9.14792C5.2246 52 2.03125 48.859 2.03125 45",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7443 52H16.7109",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4516 47H9.14851C7.4639 47 6.10156 45.657 6.10156 44V10C6.10156 8.343 7.46695 7 9.15156 7H15.2516",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7969 7H51.8469C53.5315 7 54.8969 8.343 54.8969 10V44",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2667 4H18.3C18.8612 4 19.3167 4.448 19.3167 5V13C19.3167 13.552 18.8612 14 18.3 14H16.2667C15.7055 14 15.25 13.552 15.25 13V5C15.25 4.448 15.7055 4 16.2667 4Z",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6964 4H44.7297C45.2909 4 45.7464 4.448 45.7464 5V13C45.7464 13.552 45.2909 14 44.7297 14H42.6964C42.1352 14 41.6797 13.552 41.6797 13V5C41.6797 4.448 42.1352 4 42.6964 4Z",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 21H54.9016",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 27H21.3521",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 27H34.563",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 27H47.7818",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 34H21.3521",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 41H21.3521",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 32C40.6911 32 38.8001 32.486 37.1297 33.333L33.9241 32.075C33.8072 32.029 33.6822 32 33.55 32C32.9888 32 32.5333 32.448 32.5333 33C32.5333 33.065 32.5537 33.197 32.5537 33.197L33.2165 36.458C31.5197 38.52 30.5 41.142 30.5 44C30.5 50.627 35.9625 56 42.7 56C49.4374 56 54.9 50.627 54.9 44C54.9 37.373 49.4374 32 42.7 32V32Z",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7839 39C47.7839 41.761 45.5075 44 42.7005 44C39.8935 44 37.6172 41.761 37.6172 39V38H47.7839V39Z",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6172 49C37.6172 46.239 39.8935 44 42.7005 44C45.5075 44 47.7839 46.239 47.7839 49V50H37.6172V49Z",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4403 48.2031C57.3708 52.2891 54.7132 55.5411 51.1406 57.6791",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9643 43.333C58.9643 43.8495 58.9394 44.3607 58.8906 44.8649",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.2ccf35b040afc30ecbe77de98611f63a.svg";
export { ForwardRef as ReactComponent };